import React from 'react'
import Standard from './standard'
import Workforce from './workforce'
import Gaming from './gaming'

let currentBrand = Standard

const domainMap = {
    'web-dreamjob.ldev.shadowtechllc.net': Workforce,
    'jpti.jobpassionassessment.com': Workforce,
    'djti.dreamjobdiscovery.com': Standard,
    'general': Standard,
    'workforce': Workforce,
    'gaming': Gaming,
    'standard.jobpassionassessment.com': Standard,
    'workforce.jobpassionassessment.com': Workforce,
    'game.jobpassionassessment.com': Gaming
}

export const _getDevLocalHostname = () => {
    if(process.env.NODE_ENV !== 'development') return false
    
    return localStorage.getItem('careez-dev-domain') || false
}

export const _setDevLocalHostname = (name) => {
    localStorage.setItem('careez-dev-domain', name)
}

export const getHostname = () => {
    const ldev = _getDevLocalHostname()
    
    if(ldev === false)
        return window.location.hostname
    else return ldev
}

export const setDomainBrand = (domain) => {
    _setDevLocalHostname(domain)
    if(Object.keys(domainMap).includes(domain)) {
        currentBrand = domainMap[domain]
    } else {
        currentBrand = Standard
    }
}

export const getSiteName = () => currentBrand.site

export const getDomainBrand = () => _getDevLocalHostname()

export const resetDomainBrand = () => {
    if(Object.keys(domainMap).includes(getHostname())) {
        currentBrand = domainMap[getHostname()]
    } else {
        currentBrand = Standard
    }
}

export const getFavicon = () => currentBrand.favicon

export const getCongratsImage = () => currentBrand.CongratsImage


export const getBrandName = () => {
    return currentBrand.brandName
}

export const getBrandNameFull = () => {
    return currentBrand.brandNameFull
}

export const getBrandLogo = () => {
    return currentBrand.Logo
}

export const getPrintBrandLogo = () => {
    return currentBrand.PrintLogo
}

export const getBrandCoverImage= () => {
    return currentBrand.CoverImage
}

export const getThemeList = () => {
    return currentBrand.themeData || []
}

export const getThemeDataItem = (theme) => {
    if(!(currentBrand.themeData || false)) {
        return null
    }

    return currentBrand.themeData.filter(t => t.name == theme)[0] || null
}

export const allowSignup = () => (currentBrand.SignupPage) ? true : false

export const allowDemographics = () => currentBrand.displayDemographics

export const allowNextSteps = () => currentBrand.displayNextSteps

export const allowJobs = () => currentBrand.displayJobs !== false

export const GetBrandedPage = ({pageName, ...props}) => {
    switch(pageName) {
        case 'home':
            return () => <>{currentBrand.HomePage(props)}</>
        case 'signup':
            if(currentBrand.SignupPage)
                return () => <>{currentBrand.HomePage(props)}</>
            else return <><div>No page found</div></>
        case 'privacy':
            return () => <>{currentBrand.PrivacyPage(props)}</>
        case 'terms':
            return () => <>{currentBrand.TermsPage(props)}</>
        case 'values':
            return () => <>{currentBrand.ValuesPage(props)}</>
        case 'themes':
            return () => <>{currentBrand.ThemesPage(props)}</>
        case 'titles':
            return () => <>{currentBrand.TitlesPage(props)}</>
        case 'next_steps':
            return () => <>{currentBrand.NextStepsPage(props)}</>
        default:
            return () => <div>Page not found</div>
    }
}

resetDomainBrand()
